import React from 'react';
import TeaserRow from "./TeaserRow";
import MiniShow, {MiniShowPlaceholder} from "./MiniShow";
import ShowTeaser, { ShowPlaceholder } from "./ShowTeaser";
import MiniList from "./MiniList";
import dataFetch from "./DataFetch";

export class ShowRow extends React.PureComponent {
  render() {
    if (this.props.mobileView) {
      let { title, items } = this.props;

      return <MiniList
        key={`${title}-shows`}
        title={title}
        Item={MiniShow}
        ItemPlaceholder={MiniShowPlaceholder}
        items={items}
      />;
    } else {
      let { breakpoints, title, items } = this.props;

      return <TeaserRow
        key={`${title}-shows`}
        title={title}
        breakpoints={breakpoints}
        Item={ShowTeaser}
        ItemPlaceholder={ShowPlaceholder}
        items={items}
      />;
    }
  }
}

export default dataFetch(ShowRow);